import { Dropdown as DropdownEntur, DropdownProps as DropdownEnturProps } from '@entur/dropdown';
export interface DropdownProps<Valuetype> extends DropdownEnturProps<Valuetype> {
  required?: boolean;
  // TODO: Remove once @entur/dropdown has been updated
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
}

const Dropdown = <Valuetype extends NonNullable<unknown>>(props: DropdownProps<Valuetype>) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { required, className, onBlur, ...rest } = props;
  return (
    <DropdownEntur
      clearable={!required}
      className={required ? `${className} required` : className}
      selectOnTab
      disableLabelAnimation
      {...rest}
    />
  );
};

export default Dropdown;
